const locale = {
  COMMON: {
    TITLE_LOGIN: 'ログイン',
    COLH_ACCT_NO: 'ユーザー名',
    COLH_EMAIL: 'メールアドレス',
    COLH_CHECK_EMAIL: 'メールアドレスの確認',
    TXT_ACCOUNT_DESC: 'ユーザー名を入力してください',
    COLH_CIPHER: 'パスワード',
    COLH_HELP_DOC: 'ユーザーマニュアル',
    TXT_CIPHER_DESC: 'パスワードを入力してください',
    BTN_FORGET_CIPHER: 'パスワードを忘れた場合',
    BTN_LOGIN: 'ログイン',
    BTN_LOGIN_ING: 'ログイン中...',
    BTN_BACK_TO_LOGIN: 'ログインに戻る',
    BTN_RETURN: '戻る',
    BTN_SUBMIT: '提出',
    TITLE_MENUGROUP: 'メニューグループ',
    TITLE_PURVIEW_POINT: '権限',
    TITLE_AVAILABLE_STRUCTURE: '表示可能な組織構造',
    LABEL_OPERATION: '操作',
    ENABLE: '有効',
    DISABLE: '無効',
    MSG_SERVER_ERROR: 'システムエラー。システム管理者に連絡してください。',
    MSG_NO_PERMISSION: '申し訳ございません。アクセス権がありません。システム管理者に連絡してください。',
    MSG_ASSIGN_SUCCESS: 'ユーザーには選択したロールが割り当てられました',
    MSG_ASSIGN_STRUCTURE_SUCCESS: 'ユーザーは選択した組織構造に割り当てられました',
    MSG_ASSIGN_USER_GROUP_SUCCESS: 'ユーザーは選択したユーザーグループに割り当てられました',
    ERRMSG_NO_PERMISSION: 'アクセス権がありません。ホームページに戻ります。',
    TITLE_NO_PERMISSION: 'アクセスが拒否されました',
    TITLE_ERROR: 'エラー',
    BTN_MANAGE: '管理',
    BTN_DELETE: '削除',
    BTN_REMOVE: '削除',
    BTN_CANCEL: 'キャンセル',
    BTN_CONFIRM: 'OK',
    PRMTMSG_DELETE_SUCCEED: '操作が成功しました',
    LABEL_NAME: '名前',
    BTN_EDIT: '編集',
    PRMTMSG_NAME_NOT_REPEAT: '名前は既に存在します',
    HINT_INPUT_PLACEHOLDER: '入力',
    NO_CONTENT: 'データなし',
    INLINE_NEEDED: '必須',
    INLINE_NAME_MAX_LENGTH: '最大20文字まで入力可能です',
    FORMMSG_INPUT: '説明は必須です',
    BTN_LOGOUT: 'ログアウト',
    BTN_SWITCH_OU: '企業を変更',
    TITLE_SWITCH_OU: '企業/組織を選択',
    BTN_CHANGE_CIPHER: 'パスワードを変更',
    BTN_RENAME: '名前を変更',
    BTN_I_SEE: 'OK',
    TITLE_DELETE_FAIL: '削除できませんでした',
    NOT_FOUND1: 'ページが見つかりません',
    NOT_FOUND2: '申し訳ありませんが、アクセス権がありません。',
    NOT_FOUND_MOBILE: 'このアプリケーションへのアクセス権がありません',
    NO_AUTH1: 'アクセス権がありません。',
    NO_AUTH2: '申し訳ありませんが、このアプリケーションへのアクセス権がありません。',
    NO_AUTH3: 'システム管理者に連絡してください。',
    NOT_AUTH_MOBILE: '申し訳ありませんが、このアプリケーションへのアクセス権がありません',
    TITLE_ADD_FAIL: '追加できませんでした',
    TITLE_MODIFY_FAIL: '編集できませんでした',
    TITLE_WELCOME: 'ようこそ!',
    COLH_DESCRIPTION: '説明',
    TXT_NO_ROLE: 'ロールが見つかりません。ロールを作成するか、システム管理者にお問い合わせください。',
    NO_DATA: '一致する結果がありません',
    PRMTMSG_EXIST_NAME: '名前は既に存在します',
    MSG_ACCOUNT_REQUIRED: 'ユーザー名は必須です',
    MSG_SOURCE_REQUIRED: 'ドメインは必須です',
    MSG_FILE_TYPE_LIMIT: 'アップロードされた画像の形式はサポートされていません',
    MSG_FILE_SIZE_LIMIT: '画像サイズは2MBを超えてはなりません',
    MSG_TOKEN_EXPIRED: '初期化またはリセット情報の期限が切れました',
    HINT_INVALID_PUBLIC_KEY: 'ログインに失敗しました。ページを更新して、もう一度やり直してください',
    TXT_COPY_RIGHT: 'EnOS提供',
    TXT_COPY_RIGHT1: ' EnOS提供',
    BTN_LAN_SWITCH: '言語を切り替え',
    BTN_CHANGE_ORGANIZATION: '企業/組織を変更',
    TITLE_SETTING: '設定',
    TITLE_CHANGE_CIPHER: 'パスワードを変更',
    TXT_CHANGE_CIPHER_NOTE: 'アカウントのセキュリティのために、今すぐパスワードを変更してください。',
    TITLE_SELECT_ORGANIZATION: '企業/組織を選択',
    TITLE_MENUBAR: 'メニューバー',
    BTN_EXPAND: '展開する',
    BTN_COLLAPSE: '折り畳む',
    TITLE_SESSION_CONFLICT: 'アカウントが別の場所からログインしています',
    TXT_SESSION_CONFLICT: 'アカウントが次のIPアドレスからログインしたため、ログアウトされました：{0}.',
    BTN_CHANGE_THEME: 'ナビゲーションバーのテーマを変更',
    TITLE_CHANGE_THEME: 'ナビゲーションバーのテーマを変更',
    TXT_CHANGE_THEME_HINT: 'ナビゲーションバーの色を変更するテーマを選択します',
    TXT_DARK_THEME: '黒色',
    TXT_BLUE_THEME: '青緑色',
    TITLE_TOKEN_EXPIRED: 'ログインセッション期限切れ',
    TXT_EXPIRED_CONTENT: '操作がなかったため、セキュリティ上の理由からログアウトしました。',
    TITLE_MULTI_LANGUAGE: '複数言語',
    BTN_MORE: '詳細',
    BTN_HIDE: '折り畳む',
    BTN_ADMIN: '管理者',
    TITLE_ADMIN_INFO: '管理者情報',

    TXT_LANGUAGE_EN: '英語(en-US)',
    TXT_LANGUAGE_ZH: '中国語(zh-CN)',
    TXT_LANGUAGE_JA: '日本語(ja-JP)',
    TXT_LANGUAGE_ES: 'スペイン語(es-ES)'
  },

  ROLE: {
    TITLE_ROLE_MANAGE: 'ロール',
    BTN_ADD_NEW_ROLE: '新規ロール',
    HINT_SEARCH_BY_ROLE: 'ロール名で検索',
    COLH_NAME: 'ロール名',
    COLH_DESCRIPTION: '説明',
    COLH_OPERATE: '操作',
    COLH_KEY_WORD: 'キーワード',
    FORMMSG_ROLE_MANAGE: '管理',
    FORMMSG_ROLE_DELETE: '削除',
    FORMMSG_ROLE_REMOVE: '削除',
    TITLE_ADDROLE: '新規ロール',
    TITLE_CHOOSE_APP: 'ステップ1 - アプリケーションを選択',
    TITLE_MODIFYROLE: 'ロールを編集',
    TITLE_DELETE_ROLE: 'ロールを削除できませんでした',
    TITLE_CONFIRM_ROLE: 'ロールを削除',
    LABEL_ADDROLE_NAME: '名前',
    LABEL_ADDROLE_DESCRIPTION: '説明',
    LABEL_MENUGROUP_NAME: 'メニューグループ名',
    LABEL_PERMISSION_NAME: '権限名',
    LABEL_PERMISSION_DESC: '権限の説明',
    LABEL_BELONG_APP: 'アプリケーション',
    TITLE_DELETE_FAIL: '削除できませんでした',
    BTN_CANCEL: 'キャンセル',
    BTN_EDIT: '編集',
    BTN_SUBMIT: '提出',
    BTN_CONFIRM: 'OK',
    BTN_CHECK: 'OK',
    BTN_ASSIGNMENT_MENGROUP: 'メニューグループを割り当て',
    BTN_ASSIGNMENT_PURVIEW_POINT: '権限を割り当て',
    TITLE_ASSIGNMENT_MENGROUP: 'ステップ2 - メニューグループを選択',
    TITLE_ASSIGNMENT_PURVIEW_POINT: 'ステップ2 - 権限を選択',
    PRMTMSG_ADDROLE_SUCCESS: '新規ロールが作成されました',
    PRMTMSG_DELROLE_SUCCESS: 'ロールが削除されました',
    PRMTMSG_EXIST_ROLE: 'ロール名は既に存在します',
    PRMTMSG_MODROLE_SUCCESS: 'ロールが更新されました',
    PRMTMSG_REMMGROUP_SUCCESS: 'メニューグループが削除されました',
    HINT_ADD_ROLE_PLACEHOLDER: 'ロール名を入力してください',
    HINT_ADD_ROLE_DESCRIPTION_PLACEHOLDER: 'ロールの説明を入力してください',
    PRMTMSG_ASSMGROUP_SUCCESS: 'メニューグループがロールに割り当てられました',
    PRMTMSG_ASSPERMISSION_SUCCESS: '権限がロールに割り当てられました',
    PRMTMSG_REMPERMISSION_SUCCESS: '権限がロールから削除されました',
    WINMSG_ROLEDELETE_FAIL: 'ロールがユーザーに割り当てられており、削除できません',
    WINMSG_CHECK: '閉じる',
    WINMSG_DELETE_CHECK: 'ロールに関連付けられた権限も削除されます。このロールを削除してよろしいですか?',
    BTN_FORGET_CIPHER: 'パスワードを忘れた場合',
    TXT_SELECTED_APP: '選択したアプリケーション',
    INLINE_NAME_HINT: '最大20文字まで入力可能です',
    MSG_ACCOUNT_REQUIRED: 'ロール名は必須です',
    WINMSG_MENUGRP_DELETE_CHECK: 'ロールはメニューグループに関連付けられた権限を失います。このメニューグループを削除してよろしいですか?',
    HOVER_ROLE_MENUGRP:
      'メニューグループは、アプリケーションに表示されるメニューの集まりです。ロールにメニューグループを割り当てると、そのロールのユーザーがメニューグループのメニューにアクセスできます。',
    HOVER_ROLE_PERMISSION:
      '権限は、ユーザーがアプリケーションで実行できる操作を定義します。ロールに権限を割り当てると、そのロールのユーザーは定義された操作をアプリケーションで実行できます。',
    WINMSG_PERMISSION_DELETE_CHECK:
      'ロールは、権限に関連付けられた操作へのアクセス権を失います。権限を削除してよろしいですか?',
    TITLE_DELETE_PERMISSION: '権限を削除',
    WINMSG_APP_NO_PERMISSION: 'このアプリケーションには権限が設定されていません',
    WINMSG_APP_NO_MENUGROUP: 'このアプリケーションにはメニューが設定されていません',
    TITLE_DELETE_MENUGROUP: 'メニューグループを削除',
    TITLE_ASSGIN_MENU_GROUP: 'メニューを割り当て',
    TITLE_ROLE_DETAIL: 'ロールの詳細',
    COLH_CREATE_BY: '作成者',
    COLH_CREATE_TIME: '作成日',
    HOVER_ROLE_STRUCTURE: '組織構造をロール単位で表示可能に設定します。このロールのユーザーは割り当てられた組織構造を表示できます',
    BTN_ASSIGNMENT_STRUCTURE: '組織構造を割り当て',
    LABEL_STRUCTURE_NAME: '組織構造名',
    TITLE_DELETE_STRUCTURE: '表示可能な組織構造を削除します',
    WINMSG_STRUCTURE_DELETE_CHECK: '削除されると、ロールはこの組織構造にアクセスできなくなります。組織構造を削除してよろしいですか?',
    PRMTMSG_REMSTRUCTURE_SUCCESS: '表示可能な組織構造が削除されました',
    WINMSG_APP_NO_STRUCTURE: 'このアプリケーションには、組織構造が割り当てられていません',
    TITLE_ASSIGNMENT_STRUCTURE: 'ステップ2: 組織構造を選択します',
    PRMTMSG_ASSSTRUCTURE_SUCCESS: '表示可能な組織構造が割り当てられました'
  },
  USERGROUP: {
    TITLE_PAGENAME: 'ユーザーグループ',
    BTN_ADD_USER_GROUP: '新規ユーザーグループ',
    TITLE_ADD_USER_GROUP: '新規ユーザーグループ',
    COLH_NAME: 'ユーザーグループ名',
    COLH_DESCRIPTION: '説明',
    LABEL_NAME: '名前',
    LABEL_DESCRIPTION: '説明',
    INLINE_NAME_HINT: '最大20文字まで入力可能です',
    BTN_OKTEXT: '提出',
    BTN_OKCONFIRM: 'OK',
    BTN_CANCELTEXT: 'キャンセル',
    PRMTMSG_ADD_SUCCEED: 'ユーザーグループが作成されました',
    TITLE_MODIFY_USER_GROUP: 'ユーザーグループを編集',
    WINMSG_DELETE_HINT: 'ユーザーグループに関連付けられた権限も削除されます。このユーザーグループを削除してよろしいですか?',
    PRMTMSG_DELETE_SUCCEED: 'ユーザーグループが削除されました',
    BTN_OKTEXT_IKNOW: '閉じる',
    HINT_SEARCH_USER_GROUP: 'ユーザーグループ名で検索',
    TITLE_CONFIRM_DELETE: 'ユーザーグループを削除',
    INLINE_DESCRIPTION_MAX_LENGTH: '最大50文字まで入力可能です',
    PRMTMSG_MODIFY_SUCCEED: 'ユーザーグループ情報が更新されました',
    HINT_ADD_USER_GROUP_PLACEHOLDER: 'ユーザーグループ名を入力してください',
    HINT_ADD_USER_GROUP_DESCRIPTION_PLACEHOLDER: 'ユーザーグループの説明を入力してください',
    MSG_USER_GROUP_NAME_NEEDED: 'ウユーザーグループ名は必須です',
    MSG_USER_GROUP_DESCRIPTION_NEEDED: 'ユーザーグループの説明は必須です',

    BTN_VIEW: '表示',
    COLH_ASSIGNED_USER: '割り当てられたユーザー',
    COLH_CREATE_BY: '作成者',
    COLH_CREATE_TIME: '作成日'
  },
  MENU: {
    BTN_APP_MGR: 'アプリケーション管理',
    BTN_USER_PERMISSION: 'ユーザーと権限',
    BTN_USER_MGR: 'ユーザー',
    BTN_ROLE_MGR: 'ロール',
    BTN_USER_GROUP_MGR: 'ユーザーグループ',
    BTN_STRUCTURE_MGR: '組織構造',
    BTN_SUB_ADMIN_MGR: '副管理者',
    BTN_ASSET_PERMISSION_MGR: '資産権限',
    BTN_OTHER_MGR: 'その他の設定',
    BTN_ASSET_MGR: '資産管理',
    BTN_OU_CONF: 'OU設定',
    BTN_ASSET_SYN: '資産同期化',
    BTN_ASSET_TREE: '資産ツリー',
    BTN_OU_MGR: 'OU管理者',
    BTN_PLUGIN_MGR: 'プラグイン管理',
    BTN_OU: 'OU',
    BTN_DOMAIN: 'ドメイン設定',
    BTN_SECURITY_SETTING: 'セキュリティ設定',
    BTN_ACCOUNT_PROTECTION: 'アカウント保護',
    BTN_SECURITY_MGR: 'セキュリティ管理',
    BTN_AUDIT_LOG: '監査ログ'
  },
  MENU_GROUP: {
    BTN_ADD_MENU_GROUP: '新規メニューグループ',
    DEFAULT_MENU_GROUP: 'デフォルトのメニューグループ',
    TITLE_ADD_MENU_GROUP: '新規メニューグループ',
    PRMTMSG_ADD_SUCCEED: '新規メニューグループが作成されました',
    TITLE_MODIFY_MENU_GROUP: 'メニューグループの名前を変更',
    PRMTMSG_MODIFY_SUCCEED: 'メニューグループの名前が変更されました',
    TITLE_CONFIRM_DELETE: 'メニューグループを削除',
    WINMSG_DELETE_HINT:
      'メニューグループとの関連も削除されます。メニューグループを削除してよろしいですか?',
    PRMTMSG_DELETE_SUCCEED: 'メニューグループが削除されました',
    TITLE_ASSGIN_MENU_GROUP: 'メニューを管理',
    BTN_ASSGIN_MENU_GROUP: 'メニューを管理',
    TXT_MENU_GROUP: 'メニューグループ',
    TXT_ASSGIN_MENU: '割り当て済みメニュー'
  },
  APP: {
    COLH_NAME: 'アプリケーション名',
    TITLE_CATEGORY: 'アプリケーションカテゴリ',
    TITLE_PAGENAME: 'アプリケーション',
    COLH_STATUS: '有効にする',
    COLH_STRUCTURE: '組織構造',
    HINT_ASSIGN_STRUCTURE: '組織構造を割り当て',
    TITLE_ASSIGN_STRUCTURE: '組織構造を割り当て',
    MANAGE_MENU_GROUP: 'メニューグループを管理',
    TITLE_ClOSE_APP_STATUS: 'アプリケーションを無効化',
    TITLE_OPEN_APP_STATUS: 'アプリケーションを有効化',
    WINMSG_ClOSE_APP_STATUS_HINT:
      'アプリケーションがすべてのユーザーに対して、アプリケーションラウンチャから非表示になります。アプリケーションを無効にしてよろしいですか?',
    WINMSG_OPEN_APP_STATUS_HINT:
      'アプリケーションは、承認されたユーザーのアプリケーションラウンチャに表示されます。アプリケーションを有効にしますか?',
    HINT_CHANGE_STRUCTURE: '組織構造を変更',
    TITLE_APP_MANAGE: 'アプリケーション',
    BTN_SORT: '並べ替え',
    TXT_SORT_WARNING: 'アプリケーションラウンチャでのアプリケーションの並べ替え順を設定します。',
    HINT_CAN_NOT_SORT: 'アプリケーションが見つかりません',
    BTN_CREATE_SHORTCUT_APP: '新規ショートカット',
    BTN_MGR_SHORTCUT_APP: 'ショートカットを管理',
    BTN_DELETE_SHORTCUT_APP: 'ショートカットを削除',
    TITLE_SHORTCUT: 'ショートカット',
    TITLE_DELETE_SHORTCUT_MODAL: 'ショートカットを削除',
    CONTENT_DELETE_SHORTCUT_MODAL: '削除したショートカットは元に戻すことはできません。ショートカットを削除してよろしいですか?',
    MSG_DELETE_SHORTCUT_SUCCESS: 'ショートカットが削除されました',
    TXT_SHORTCUT_DETAIL: 'ショートカットの詳細',
    TITLE_ADD_SHORTCUT_FAIL: 'ショートカットを作成できませんでした',
    MSG_ADD_SHORTCUT_SUCCESS: 'ショートカットが作成されました',
    COLH_MAIN_APP: 'メインアプリケーション',
    COLH_APP_NAME: '名前',
    COLH_NAME_ZH: '名前(中国語)',
    COLH_NAME_EN: '名前(英語)',
    COLH_CATEGORY: 'アプリケーションカテゴリ',
    COLH_DESCRIPTION: '説明',
    TITLE_MODIFY_BASIC_INFO: '基本情報を編集',
    MESSAGE_MODIFY_SUCCEED: '基本情報が更新されました',
    TITLE_ADDED_APP: '追加済みメニュー',
    BTN_ADD_MENU: 'メニューを追加',
    TXT_ADD_FROM_OTHER_APP: '他のアプリケーションから追加',
    TXT_ADD_FIRST_CLASS_MENU: 'トップレベルメニューを追加',
    TITLE_CHOOSE_APP: 'ステップ1 - アプリケーションを選択',
    TITLE_ASSIGN_MENU: 'ステップ2 - メニューを選択',
    HINT_ADD_SUB_MENU: 'サブメニューを追加',
    HINT_DELETE: '削除',
    HINT_EDIT: '編集',
    HINT_ADD_MENU_ZH_PLACEHOLD: 'メニュー名を中国語で入力してください',
    HINT_ADD_MENU_EN_PLACEHOLD: 'メニュー名を英語で入力してください',
    TITLE_CONFIRM_DELETE: 'メニューを削除',
    TXT_CONFIRM_DELETE: '削除したメニューを元に戻すことはできません。メニューを削除してよろしいですか?',
    TITLE_CONFIRM_DELETE_AGAIN: 'トップレベルメニューとそのサブメニューを削除',
    HINT_DELETE_MENU_SUCCEED: 'メニューが削除されました',
    HINT_CREATE_MENU_SUCCEED: 'メニューが追加されました',
    HINT_ADD_MENU: '他のアプリケーションからメニューを追加するか、新規のトップレベルメニューを追加できます。',
    WINMSG_APP_NO_MENU: '利用可能なメニューがありません',
    TXT_SOURCE: 'ソース',
    BTN_API_AUTHORIZATION: 'API承認',
    MSG_API_AUTHORIZATION: 'API承認',
    TXT_API_AUTHORIZATION: 'アプリケーションがAPIを通して、以下の操作を実行できるようにします',
    TXT_API_AUTHORIZATION_USER: 'OU内のすべてのユーザーのID、ユーザー名、メールアドレス、電話番号を取得します',
    TXT_API_AUTHORIZATION_ASSET: 'OU内のすべての資産のIDと名前を取得します',
    MSG_API_AUTHORIZATION_SUCCESS: 'API承認設定が更新されました',
    BTN_VIEW_MENU: 'メニューを表示',
    BTN_SORT_MENU: 'メニューを並べ替え',
    TXT_SORT_MENU_WARNING: 'メニューの並べ替え順を変更します。新しい並べ替え順は、次回のユーザーログイン時に有効になります。',
    HINT_MODIFY_MENU_SUCCESS: 'メニューの名前が変更されました',
    HINT_SORT_MENU_SUCCESS: 'メニューの並べ替え順が更新されました',
    MESSAGE_ADD_NEEDED: 'メニュー名を入力してください',
    MESSAGE_RENAME_NEEDED: 'ショートカット名を入力してください',
    MESSAGE_RENAME_MENU_GROUP_NEEDED: 'メニューグループ名を入力してください',
    HINT_SORT_APP_SUCCESS: 'アプリケーションが新しい順序で並べ替えされました',
    HINT_ASSIGN_APP_STRUCTURE: '組織構造が割り当てられました',
    MSG_ADD_MENU_SUCCESS: 'メニューが追加されました',
    MSG_SHORTCUT_NAME_NEEDED: 'ショートカット名は必須です',
    COLH_NAME_JA: '名前(日本語)',
    COLH_NAME_ES: '名前(スペイン語)',
    LABEL_URL: 'URL',
    TXT_API_AUTHORIZATION_ROLE: 'OU内のすべてのロールのIDと名前を取得します',
    WINMSG_APP_NO_PERMISSION: '利用できる権限がありません',
    TITLE_DELETE_PERMISSION: '権限を削除',
    WINMSG_PERMISSION_DELETE_CHECK:
      'アプリケーションショートカットは、権限に関連付けられた操作へのアクセス権を失います。権限を削除してよろしいですか?',
    TITLE_ADDED_PER: '追加済み権限',
    BTN_ASSIGNMENT_PURVIEW_POINT: '権限を追加',
    HINT_ADD_PER: '他のアプリケーションから権限を追加できます。権限を追加した後、これらの権限をロールに割り当てて、ユーザーが関連する操作にアクセスできるようにすることができます。',
    PRMTMSG_ASSPERMISSION_SUCCESS: '権限が正常に追加されました',
    PRMTMSG_REMPERMISSION_SUCCESS: '権限が削除されました',
    TITLE_DOWNLOAD_NAME: 'ユーザー一覧',
    TXT_STRUCTURE_SELECT: '最大{0}つの組織構造を選択します',
    TITLE_UNBIND: '割り当てられた組織構造を削除',
    WINMSG_UNBIND: '組織構造がロールに割り当てられました。削除されると、ロールは組織構造を表示できなくなります。 注意して進めてください。',
    NO_STRUCTURE: '利用可能な組織構造がありません。まず、組織構造を作成してください',
    BTN_ALL_APP: 'すべてのアプリケーション',
    BTN_PURCHASED_APP: '購入済みのアプリケーション',
    BTN_SELFDESIGNED_APP: 'カスタマイズしたアプリケーション',
    COLH_NEWNAVIGATION: '新しいナビゲーションスタイル',
    TXT_NEWNAVIGATION: '新しいナビゲーションスタイルを無効にすると、アプリケーションは現在のスタイルのままになります',
    TITLE_OLDNAVIGATION: '古いナビゲーションスタイル',
    TXT_SHOW_MENU_NAME: 'ラベルを表示',
    TXT_SHOW_ICON: 'アイコンを表示',
    TXT_FOLDER_SUBMENU: 'サブメニューを展開/折り畳む',
    TXT_ICON_MENU: 'アイコンのみ表示',
    TITLE_CLOSE_NEWNAVIGATION: '新しいナビゲーションを無効にしますか?',
    TXT_CLOSE_NEWNAVIGATION: '新しいナビゲーションを無効にすると、ナビゲーションはアイコンなしの古いスタイルに切り替わります。',
    BTN_APP_MENUMANAGEMENT: 'メニュー管理',
    TXT_MENU_MANAGEMENT: 'メニュー管理'
  },
  MENU_MANAGEMENT: {
    TXT_SEARCH: 'メニュー名またはID で検索',
    COLH_MENU_ICON_NAME: 'アイコン/ラベル',
    COLH_MENU_CODE: 'ID',
    COLH_ORDER: '並べ替え',
    COLH_URL: 'URL',
    TITLE_ADDITION: '詳細',
    TITLE_SWITCH: '切替え先',
    TITLE_OPEN: '展開する',
    TXT_SWITCHMENU: 'このサブメニューを開く',
    TITLE_MENU_NAME: '名前',
    TITLE_MENU_PROPERTY: 'プロパティ',
    TITLE_OPEN_SUBMENU: 'サブメニューを展開する',
    TITLE_SWITCH_SUBMENU: 'サブメニューを開く',
    TITLE_SELECT_ICON: 'アイコンを選択',
    BTN_SAVE: '保存',
    MSG_ICON_SAVE_SUCCESSFULLY: 'アイコンが保存されました!'
  },
  STRUCTURE: {
    TITLE_STRUCTURE_MANAGE: '組織構造',
    TITLE_MANAGE_STRUCTURE: '組織構造',
    BTN_ADD_STRUCTURE: '新規組織構造',
    COLH_NAME: '組織構造名',
    WINMSG_DELETE_STRUCTURE_HINT:
      '削除した組織構造を元に戻すことはできません。組織構造を削除してよろしいですか?',
    TITLE_ADD_STRUCTURE: '新規組織構造',
    PRMTMSG_ADD_SUCCEED: '組織構造が作成されました',
    PRMTMSG_ADD_CHILD_SUCCEED: 'ノードが追加されました',
    DELETE_STRUCTURE_SUCCEED: '組織構造が削除されました',
    INLINE_STRUCTURE_AMOUNT: '最大5つの組織構造を作成できます',
    COLH_AUTO_ASSGIN_STATUS: '自動資産承認',
    TITLE_ClOSE_STRUCTURE_AUTO_DISPATCH: '資産承認を無効にする',
    TITLE_OPEN_STRUCTURE_AUTO_DISPATCH: '資産承認を有効にする',
    WINMSG_ClOSE_STRUCTURE_AUTO_DISPATCH:
      'ユーザーは、自分が割り当てられているノードのすべての子資産へのアクセス権を失います。自動資産承認を無効にしてよろしいですか?',
    WINMSG_OPEN_STRUCTURE_AUTO_DISPATCH:
      'ユーザーは、自分が割り当てられているノードのすべての子資産へのアクセス権を自動的に取得します。自動資産承認を有効にしますか?',
    BTN_ADD_SUB_NODE: '子ノードを追加',
    BTN_MANAGE_ASSET: '資産を管理',
    BTN_MANAGE_USER: 'ユーザーを表示',
    TITLE_ADD_NODE: '子ノードを追加',
    LABEL_NODE_NAME_ZH: 'ノード名(zh-CN)',
    LABEL_NODE_NAME_EN: 'ノード名(en-US)',
    TITLE_CONFIRM_DELETE_STRUCTURE: '組織構造を削除',
    TITLE_CONFIRM_DELETE: 'ノードを削除',
    WINMSG_DELETE_HINT: '削除したノードは元に戻すことはできません。ノードを削除してよろしいですか?',
    TITLE_MODIFY_STRUCTURE: '名前を変更',
    PRMTMSG_ASSIGN_SUCCEED:
      '資産割り当てが更新されました。セキュリティ上の理由から、ユーザーは3分後に割り当てられた資産にアクセスできます。',
    TITLE_MANAGE_USER: 'ユーザーを表示',
    BTN_SYNC_ASSETS: '資産を同期',
    PRMTMSG_SYNC_SUCCEED: '資産が同期されました',
    BTN_SYNCING: '同期中...',
    HINT_SYNC_ASSETS_HINT: '「資産を同期」をクリックして、OUから資産を同期します',
    PRMTMSG_MODIFY_SUCCEED: 'ノードが更新されました',
    UNASSIGNED_ASSET: '未割り当ての資産',
    ASSIGNED_ASSET: '割り当て済み資産',
    HINT_ADD_STRUCTURE_PLACEHOLDER: '組織構造名を入力してください',
    INLINE_NANME_NEEDED: 'ノード名は必須です',
    MSG_STRUCTURE_NAME_NEEDED: '組織構造名は必須です',
    MSG_STRUCTURE_NAME_PATTERN: '縦棒「|」およびカンマ「,」 「，」は使用できません',
    INLINE_STRUCTURE_HINT:
      '組織構造は、ノードを管理単位として使用する資産管理階層です。ユーザーが割り当てられているノードのすべての子資産にユーザーが自動的にアクセスできるように、組織構造を設定できます。',
    BTN_USER: 'ユーザー',
    BTN_ASSET: '資産',
    LABEL_NAME: '名前',
    BTN_ADD_TAG: 'タグを追加',
    BTN_EDIT_TAG: 'タグを編集',
    LABEL_TAG_ID: 'タグキー',
    MSG_TAG_ID_INPUT: '文字、数字、アンダースコア(_)、ハイフン(-)、およびスラッシュ(/)のみを使用してください',
    LABEL_TAG_VALUE: 'タグ値',
    HINT_INPUT_TAG_VALUE: 'タグ値を入力してください',
    HINT_INPUT_TAG_ID: 'タグキーを入力してください',
    TAB_TAG: 'タグ',
    TITEL_DELETE_TAG: 'タグを削除しますか？',
    TXT_DELETE_TAG_HINT: '削除したタグは元に戻すことはできません。このタグを削除してよろしいですか?',
    PRMTMSG_CREATE_TAG_SUCCEED: 'タグが追加されました',
    PRMTMSG_MODIFY_TAG_SUCCEED: 'タグが編集されました',
    MSG_TAG_KEY_EXIST: 'このタグキーは既に存在します',
    MSG_DELETE_STRUCTURE_TAG_SUCCEED: 'タグが削除されました',
    BTN_SORT: 'ソート順',
    MSG_SORT_SUCCESS: '保存されました',
    MSG_SORT_FAILED: '保存できませんでした',
    MSG_ASSETSORT_FAILED: '操作が失敗しました、もう一度やり直してください',
    TXT_SORT_WARNING: 'ノードの並び替えは、同じ親ノード内でのみ可能です。ノードを別の親ノードに移動することはできません。'
  },
  USER: {
    BTN_SEARCH: '検索',
    TITLE_PAGE_NAME: 'ユーザー',
    TITLE_USER_DETAIL: 'ユーザーの詳細',
    TITLE_USER_ROLE: '割り当て済みロール',
    TITLE_USER_STRUCTURE: '割り当て済み組織構造',
    TITLE_USER_USER_GROUP: '割り当て済みユーザーグループ',
    TITLE_MODIFY_USER: 'ユーザー情報を編集',
    BTN_CREATE_USER: 'ユーザーを追加',
    TITLE_CREATE_USER_FAILED: 'ユーザーを追加できませんでした',
    MSG_CREATE_USER_FAILED: 'ユーザーは既に存在するため、再度追加できません',
    BTN_ASSIGN_ROLE: 'ロールを割り当て',
    TITLE_ASSIGN_ROLE: 'ロールを割り当て',
    BTN_ASSIGN_STRUCTURE: '組織構造を割り当て',
    TITLE_ASSIGN_STRUCTURE: '組織構造を割り当て',
    BTN_ASSIGN_USER_GROUP: 'ユーザーグループを割り当て',
    TITLE_ASSIGN_USER_GROUP: 'ユーザーグループを割り当て',
    TXT_SEARCH: 'ユーザー名または姓名で検索',
    BTN_MANAGE: '管理',
    BTN_REMOVE_FROM_OU: '企業/組織から削除',
    TITLE_REMOVE_FROM_OU: 'ユーザーを削除',
    MSG_REMOVE_FROM_USER_GROUP: 'ユーザーグループから削除',
    MSG_REMOVE_FROM_OU:
      'ユーザーが削除されると、ユーザーには企業または組織の資産へのアクセス権がなくなります。ユーザーを削除してよろしいですか?',
    MSG_ASSIGN_ROLE: 'ロールに割り当てられると、ユーザーはロールに割り当てられているメニュー権限と操作権限を持つことになります。',
    MSG_ASSIGN_USER_GROUP: 'ユーザーグループに追加されると、ユーザーにはユーザーグループの資産を表示するための権限が割り当てられます。',
    MSG_ASSIGN_STRUCTURE:
      '組織に追加されると、ユーザーには組織構造の資産を表示するための権限が割り当てられます。',
    MSG_REMOVE_SUCCESS: 'ユーザーが企業/組織から削除されました',
    COLH_ACCT_NO: 'ユーザー',
    COLH_EMAIL: 'メールアドレス',
    COLH_NICKNAME: '姓名',
    COLH_PHONE: '電話番号',
    MSG_REMOVE_SELF: '自分自身のユーザーアカウントを削除することはできません',
    TITLE_CONFIRM_ADD: 'ユーザーを追加',
    MSG_CONFIRM_ADD_USER: 'ユーザー {0} を現在の企業/組織に追加しますか?',
    TITLE_MAIL_TO: '招待メールの送信先:',
    MSG_ENTER_CORRECT_FORMAT: '有効なメールアドレスを入力してください',
    MSG_EMAIL_NO_RESULT: '一致する結果がありません。 ',
    TITLE_CREATE_JOIN: 'ユーザーアカウントを作成します',
    MSG_CREATE_EMAIL_SUCCESS: 'ユーザーアカウントが作成され、ユーザーに招待メールが送信されました',
    MSG_CREATE_EMAIL_NO_EMAIL_SUCCESS: 'ユーザーアカウントが作成され、追加されました',
    MSG_ACCOUNT_EXIST: 'ユーザー名は既に存在します',
    MSG_ACCOUNT_REQUIRED: 'ユーザー名は必須です',
    TXT_ENTER_EMAIL: 'メールアドレスを入力してください',
    TXT_ENTER_USER_EMAIL: 'ユーザーのメールアドレスを入力してください',
    MSG_CIPHER_NOT_SAME: '入力されたパスワードが一致しません',
    MSG_ENTER_CIPHER: 'パスワードを入力してください',
    MSG_ENTER_EMAIL_AGAIN: 'もう一度メールアドレスを入力してください',
    MSG_ENTER_CIPHER_AGAIN: 'もう一度パスワードを入力してください',
    LABEL_CIPHER: 'パスワードの設定',
    LABEL_CONFIRM_CIPHER: 'パスワードの確認',
    TITLE_RESET_CIPHER: 'パスワードのリセット',
    BTN_RESET_CIPHER: 'パスワードのリセット',
    TXT_CONFIRM_RESET_CIPHER: 'パスワードのリセット',
    MSG_CONFIRM_RESET_CIPHER: 'パスワードのリセット用のメールがユーザーに送信されます。パスワードをリセットしてよろしいですか？',
    MSG_TRIGGER_RESET_CIPHER: 'パスワードのリセット用のメールがユーザーに送信されました。',
    MSG_RESET_CIPHER_SUCCESS: 'ログインページに戻ります...',
    BTN_REDIRECT_IM: '今すぐ戻る',
    MSG_SEND_RESET_EMAIL_SUCCESSFULLY: '{0}、これは、24時間以内に期限が切れます。',
    MSG_JUMP_TO_MAIL_BOX: '今すぐメールを確認して、パスワードをリセットしてください',
    BTN_CHANGE_CIPHER_SUCCESSFULLY: 'パスワードが更新されました',
    HOVER_USER_ROLE:
      'ロールは、メニューアクセス権限や操作権限などの機能権限の集まりです。ユーザーにロールを割り当てると、ユーザーは対応するメニューや操作にアクセスできるようになります。',
    HOVER_USER_PERMISSION:
      'ユーザーを組織構造のノードに割り当てて、資産の自動承認を有効にすると、ユーザーは自動的に子資産にアクセスできるようになります。',
    HOVER_USER_STRUCTURE:
      '1つのユーザーグループに複数のユーザーを割り当てて、グループに資産権限を割り当てると、同じユーザーグループのユーザーが同じ資産権限を持つようになります。 ',
    TITLE_CONFIRM_REMOVE_ROLE: 'ロールを削除',
    TITLE_CONFIRM_REMOVE_STRUCTURE: '組織構造を削除',
    TITLE_CONFIRM_REMOVE_USER_GROUP: 'ユーザーグループを削除',
    WINMSG_DELETE_CHECK: 'ユーザーは関連付けられた権限を失います。削除してよろしいですか?',
    WINMSG_DELETE_ROLE_CHECK: 'ユーザーはロールに関連付けられた権限を失います。ロールを削除してよろしいですか?',
    WINMSG_DELETE_STRUCTURE_CHECK:
      'ユーザーは組織構造に関連付けられた権限を失います。組織構造からユーザーを削除してよろしいですか?',
    WINMSG_SUB_DELETE_STRUCTURE_CHECK:
      'ユーザーは組織構造に関連付けられた権限を失います。また、ユーザーを管理できなくなります。組織構造からユーザーを削除してよろしいですか?',
    WINMSG_DELETE_USERGROUP_CHECK:
      'ユーザーはユーザーグループに関連付けられた権限を失います。ユーザーグループからユーザーを削除してよろしいですか?',
    PRMTMSG_REMOVE_SUCCEED: 'ユーザーロールが削除されました',
    STRUCTURE_REMOVE_SUCCEED: 'ユーザーが組織構造から削除されました。',
    USER_GROUP_REMOVE_SUCCEED: 'ユーザーがユーザーグループから削除されました。',
    PRMTMSG_MODIFY_USER_SUCCEED: '正常に更新されました',
    COLH_DESCRIPTION: '説明',
    COLH_USER_ROLE: 'ロール',
    COLH_USER_STRUCTURE: '組織構造',
    COLH_USER_USER_GROUP: 'ユーザーグループ',
    MSG_ACCOUNT_NUMBER_REQUIRED: '数字を入力してください',
    TXT_SELECTED_STRUCTURE: '選択した組織構造',
    MSG_EMAIL_NOT_SAME: '入力されたメールアドレスが一致しません',
    LABEL_NEW_CIPHER: '新しいパスワード',
    LABEL_OLD_CIPHER: '古いパスワード',
    LABEL_CONFIRM_NEW_CIPHER: '新しいパスワードの確認',
    MSG_NO_CIPHER: 'パスワードは必須です',
    MSG_ENTER_OLD_CIPHER: '古いパスワードを入力してください',
    MSG_ENTER_NEW_CIPHER: '新しいパスワードを入力してください',
    MSG_NEW_CIPHER_NOT_SIMILAR: '入力されたパスワードが一致しません',
    MSG_NEW_OLD_CIPHER_SIMILAR: '新しいパスワードは古いパスワードと同じにすることはできません',
    MSG_MODIFY_CIPHER_SUCCESS: 'パスワードが変更されました',
    MSG_ACCOUNT_CANNOT_CHANGE: 'アカウントの種類とドメインは変更できません',
    MSG_CREATE_ADD_USER: '新しいユーザーアカウント',
    MSG_INVALIDATE_CIPHER: 'パスワードはパスワード要件を満たしていません',
    MSG_CIPHER_PATTERN:
      'パスワードは8文字以上で、大文字、小文字、数字をそれぞれ1つ以上含む必要があります。特殊文字(!@#%&$*()[]{}|)もサポートされています。',
    HINT_USER_REQUIRED: 'ユーザー名は必須です',
    HINT_REGION_REQUIRED: '管理可能な範囲は必須です',
    MSG_SUB_ADMIN_ADD_EXIST_USER: 'ユーザーは既に存在するため、再度追加できません。',
    TITLE_USER_BATCH_IMPORT: '一括インポート',
    BTN_BATCH_IMPORT: '一括インポート',
    MSG_DOWNLOAD_IMPORT_TEMPLATE: 'テンプレートをダウンロード',
    MSG_UPLOAD_WRITTEN_FILE: 'ファイルをアップロード',
    MSG_A_IMPORT_TEMPLATE_DOWNLOAD: 'テンプレートをダウンロード',
    TITLE_UPLOAD_FILE_ERROR: 'アップロードが失敗しました',
    TITLE_UPLOAD_FILE_FORMAT_ERROR: 'ファイル形式が無効です',
    TITLE_UPLOAD_FILE_SIZE_ERROR: 'レコードが制限を超えています ',
    MSG_UPLOAD_FILE_SIZE_ERROR: 'ファイルサイズは2MBを超えてはなりません',
    MSG_UPLOAD_FILE_FORMAT_ERROR: ' .xlsまたは.xlsxファイルのみアップロードしてください',
    BTN_UPLOAD_SELECT: 'ファイルを選択',
    BTN_START_UPLOAD: 'アップロード',
    TITLE_BATCH_IMPORT_EXPLANATION: '一括インポート機能を使用すると、同時に複数のユーザーを追加して、ロールと組織構造を割り当てることができます。テンプレートをダウンロードして、必要な情報をテンプレートに入力し、ファイルをアップロードしてください。',
    MSG_A_BATCH_IMPORT_EXPLANATION: 'ファイルサイズの上限: 2MB、1ファイル当たりのの最大ユーザーレコード数: 1000、ファイル形式: {0}',
    TITLE_RECENT_FAILED_RECORD: '前回のインポート',
    MSG_A_DOWNLOAD_FAILED_IMPORT_RECORD: 'エラーログをダウンロードしてください',
    BTN_UPLOADING: 'アップロード中',
    BTN_PROCESSING: '処理中',
    MSG_HISTORY_SUCCESS_RECORDS: '{0}に、{1}名のメンバーのインポートに成功し',
    MSG_HISTORY_FAILED_RECORDS: '、{0}名のメンバーのインポートに失敗しました。',
    TITLE_TEMPLATE_NAME: 'Template.xlsx',
    TITLE_HISTORY_RECORDS_NAME: '{0}_Failed Records.xlsx',
    LABEL_USER_TYPE: '種類',
    LABEL_USER_ACCOUNT_AD: 'ドメインアカウント',
    LABEL_USER_ACCOUNT_INTERNAL: '内部アカウント',
    LABEL_USER_SOURCE: 'ドメイン',
    MSG_CIPHER_RULES: 'パスワード規則: {0}',
    TITLE_CONFIRM_RESET_CIPHER: 'パスワードのリセット',
    MSG_CONFIRM_RESTE_CIPHER: 'システムは新しいパスワードを生成します。パスワードをリセットしてよろしいですか?',
    TITLE_CONFIRM_RESTE_CIPHER: 'システムは新しいパスワードを自動的に生成します。パスワードをリセットしてよろしいですか?',
    MSG_NOTICE_CONTENT: 'このユーザーにメール通知を送信できません。ログインURL、ユーザー名、パスワードをユーザーに手動で送信してください。',
    BTN_COPY_ACCOUNT_CIPHER: 'コピー',
    TXT_CORY_SUCCESS: 'ユーザー名とパスワードがコピーされました',
    TITLE_RESET_CIPHER_SUCCESS: 'パスワードがリセットされました',
    TITLE_CREATE_ADD_ACCOUNT_SUCCESS: 'ユーザーアカウントが作成され、追加されました',
    HINT_INCORRECT_PHONE_NUMBER: '有効な電話番号形式を入力してください',
    PLACEHOLD_SELECT_USER: '選択',

    COLH_ACCOUNT_START_TIME: '有効期間開始日',
    HINT_ACCOUNT_START_TIME: 'アカウントが有効になり、ユーザーがOUにログインできる日を指します',
    COLH_ACCOUNT_EXPIRE_TIME: '有効期間終了日',
    HINT_ACCOUNT_EXPIRE_TIME: 'アカウントの有効期間の最終日。この日を過ぎると、ユーザーはOUにログインできなくなります。',
    BTN_BATCH_EXPORT: '一括エクスポート',
    TITLE_BATCH_EXPORT: '一括エクスポート',
    COLH_CREATE_TIME: '作成日',
    TITLE_COMPANY: '会社',
    TITLE_DEPARTMENT: '部署',
    TITLE_POSITION: '役職'
  },
  SUB_ADMIN: {
    COLH_NAME: 'ユーザー',
    COLH_MANAGEMENT_REGION: '管理可能な範囲',
    COLH_AVAILABLE_ROLE: '管理可能なロール',
    BTN_MANAGE: '管理',
    BTN_REMOVE_FROM_OU: '削除',
    TITLE_REMOVE_SUB_ADMIN: '副管理者を削除',
    TEXT_REMOVE_SUB_ADMIN: 'ユーザーは管理権限を失います。副管理者を削除してよろしいですか?',
    TITLE_REMOVE_FAIL: '副管理者を削除できませんでした',
    MSG_REMOVE_SUCCESS: '副管理者が削除されました',
    BTN_CREATE_SUB_ADMIN: '副管理者を追加',
    TEXT_COMMA: '、',
    TITLE_PAGE_NAME: '副管理者',
    TITLE_NEW_SUB_ADMIN: '副管理者を追加',
    TITLE_MANAGE_SUB_ADMIN: '副管理者の詳細',
    INLINE_SUB_ADMIN_DETAIL_HINT:
      '副管理者は、ロールや資産権限の割り当てなど、特定の組織構造のユーザー権限を管理できます。',
    TITLE_SELECT_USER: 'ユーザーを選択',
    TITLE_SET_REGION: '管理可能な範囲を選択',
    TITLE_SELECT_ROLE: '管理可能なロールを選択',
    TEXT_REGION_HINT:
      '副管理者が管理できる組織構造を選択します。',
    TEXT_ROLE_HINT: '副管理者がユーザーに割り当てることができるロールを選択します。',
    BTN_SUBMIT: '提出',
    HINT_SELECT_USER: 'ユーザー名で検索',
    HINT_SET_REGION: '組織構造を選択',
    HINT_SELECT_ROLE: 'ロールを選択',
    HINT_NO_MATCH_DATA: '一致する結果がありません',
    HINT_USER_REQUIRED: 'ユーザー名は必須です',
    HINT_REGION_REQUIRED: '管理可能な範囲は必須です',
    MSG_CREATE_SUCCESS: '副管理者が追加されました',
    MSG_UPDATE_SUCCESS: '副管理者情報が更新されました',
    BTN_VIEW: '表示',
    COLH_MANAGEMENT_AUTHORITY: '管理権限',
    COLH_ALLOCATION: '割り当て方法',
    COLH_ASSIGNED_MANAGEMENT_REGION: '管理可能な範囲',
    TXT_SUBADMIN_NAME: '副管理者',
    TITLE_SELECT_SUB_ADMIN: '副管理者',
    HINT_SELECT_ALLOCATION: '割り当て方法を選択',
    HINT_SELECT_REGION: '管理可能な範囲を選択',
    TITLE_SELECT_FUNCTION: '利用可能な機能',
    TXT_APPLICATION: 'アプリケーションを管理', // 目前后端提供
    TXT_USER: 'ユーザー管理', // 目前后端提供
    TXT_ROLE: 'ロールを管理', // 目前后端提供
    TXT_USER_GROUP: 'ユーザーグループを管理', // 目前后端提供
    TXT_ASSET_PERMISSION: '資産権限を割り当て', // 目前后端提供
    TXT_AUDIT_LOG: '監査ログを管理', // 目前后端提供
    TXT_ASSIGNED_BY_ORGANIZATION_STRUCTURE: '組織構造単位で割り当て',
    TXT_ASSIGNED_BY_USER_GROUP: 'ユーザーグループ単位で割り当て',
    TXT_ASSIGNED_BY_ROLE: 'ロール単位で割り当て',
    BTN_ADD: '割り当て方法を追加',
    TXT_DELETE_CONFIRM: '割り当て方法を削除しますか?',
    MSG_DELETE_CONFIRM: '副管理者が選択した範囲の管理者権限を失います',
    HINT_APPLICATION: '副管理者がアプリケーションのメニューグループを管理できます',
    HINT_USER: '副管理者がユーザーアカウントを作成、編集、削除、一括インポート、一括エクスポートできます。副管理者は、ロール、ユーザーグループ、組織構造をユーザーに割り当てることもできます',
    HINT_ROLE: '副管理者は、自分に割り当てられたロールや自分が作成したロールを管理できます',
    HINT_USER_GROUP: '副管理者は、自分に割り当てられたユーザーグループや自分が作成したユーザーグループを管理できます',
    HINT_ASSET_PERMISSION: '副管理者は、資産権限をユーザーまたはユーザーグループに割り当てることができます',
    HINT_AUDIT_LOG: '副管理者は、自分の管理イベント、管理するユーザーのログイン/ログアウトイベントを表示およびエクスポートできます',
    HINT_ALLOCATIONS: '副管理者が管理できるユーザーグループ、ロール、および資産を割り当てます',
    HINT_OPERATIONS: '副管理者の機能を選択します',
    TXT_STRUCTURES: '組織構造',
    TXT_ROLES: 'ロール',
    TXT_USER_GROUPS: 'ユーザーグループ'
  },
  ASSET_PERMISSION: {
    TXT_USER: 'ユーザー',
    TXT_USER_GROUP: 'ユーザーグループ',
    HINT_SEARCH: 'ユーザー名で検索',
    HINT_USER_SEARCH: 'ユーザー名またはメールアドレスで検索',
    HINT_USER_GROUP_SEARCH: 'ユーザーグループ名で検索',
    BTN_MANAGE_ASSET: '資産を管理',
    COLH_NAME: '割り当て済み資産',
    TITLE_MANAGE_ASSET: '資産を管理',
    TXT_ASSGIN_TO: '割り当て先',
    TITLE_CONFIRM_REMOVE: '資産を削除',
    ASSET_PERMISSION_USER: 'ユーザーは資産へのアクセス権を失います。資産を削除してよろしいですか?',
    ASSET_PERMISSION_USER_GROUP: 'ユーザーグループは資産へのアクセス権を失います。資産を削除してよろしいですか?',
    UNASSIGNED_ASSET: '未割り当ての資産',
    ASSIGNED_ASSET: '割り当て済み資産',
    INLINE_ASSET_PERMISSION_DETAIL_HINT:
      'ユーザーまたはユーザーグループに資産を割り当てて、対応する資産データをアプリケーションに表示できるようにします。'
  },
  ASSET_TREE: {
    BTN_MANAGE: '管理',
    TITLE_PAGENAME: '組織構造を管理',
    TITLE_ASSET_SYNC:
      '資産同期化は、接続され、かつタグ付けされた資産をEnOSコンソールから同期化するプロセスです。同期化が完了した後にのみ、ユーザーに資産権限を割り当てることができます。',
    COLH_ASSET_NAME: '資産名',
    COLH_SYNC_TIME: '同期化日時',
    MSG_SYNC_ASSET_TREE_FAIL: '後でもう一度お試しください',
    MSG_SYNC_ASSET_TREE_SUCCESS: '同期化完了',
    BTN_SYNC_ING: '同期化',
    MSG_PROMPT_ASSETS_ALLOCATION: 'セキュリティ上の理由から、ユーザーは資産が割り当てられてから3分後に資産にアクセスできます。'
  },
  OU: {
    TITLE_INFO: '基本情報',
    TITLE_ADMIN: 'OU管理者',
    TITLE_PERSONALITY: 'カスタマイズ',
    TITLE_OU_NAME: 'OU名',
    TITLE_OU_ADDRESS: '所在地',
    TITLE_INDUSTRY: '業種',
    TITLE_LOGO: 'ロゴ',
    TITLE_ADMIN_ACCOUNT: '管理者アカウント',
    TITLE_ADMIN_NAME: '管理者名',
    BTN_CHANGE_MANAGER: '管理者を変更',
    TITLE_CHANGE_MANAGER: '管理者を変更',
    LABEL_CURRENT_ADMIN: '現在の管理者',
    LABEL_NEW_ADMIN: '新しい管理者',
    TITLE_CHANGE_ADMIN: '管理者を変更',
    WINMSG_CHANGEADMIN_HINT1: '{0}が新しい管理者に設定されます。',
    WINMSG_CHANGEADMIN_HINT2: '管理者ではなくなります。',
    WINMSG_CHANGEADMIN_HINT3: '管理者を変更してよろしいですか?',
    HINT_NO_MATCH_DATA: '一致するデータが見つかりません',
    HINT_INPUT_HINT: 'ユーザー名またはメールアドレスで検索',
    INLINE_NEEDED: '新しい管理者は必須です',
    BTN_REUPLOAD: '画像をアップロード',
    MSG_FILE_UPLOAD_SUCCEED: '画像がアップロードされました',
    TXT_CHANGE_LOGO_HINT: 'ロゴは、ナビゲーターバーの上部に表示されます。200 * 32ピクセル、透明な背景、PNGまたはSVG形式の仕様の画像を使用することをお勧めします。',
    TXT_SEARCH: 'OU名で検索',
    TITLE_LANGUAGE_SETTING: '言語設定',
    TITLE_LANGUAGE: '利用可能な言語',
    TXT_EDIT: '編集',
    TITLE_LAN_SETTING: '言語設定',
    HINT_EDIT_LAN_HINT: '企業または組織のすべてのユーザーが利用できる言語を選択します。',
    HINT_LANG_SETTING_SUCCEED: '言語設定が更新されました',
    TITLE_PAGEFOOTER: 'フッター',
    TITLE_EDITPAGEFOOTER: 'フッターを編集',
    MSG_NULLFOOTER: 'フッターが空白です',
    TXT_NULL: '(空白)',
    MSG_EDITPAGEFOOTER_SUCCESS: 'フッターが保存されました',
    HINT_NOTBUY: '現在のOUはこの機能を購入していません'
  },
  PORTAL: {
    BTN_ADMIN_CONSOLE: '管理コンソール',
    TITLE_IFRAME_ERROR: 'Iframeエラー',
    MSG_INVALIDATE_URL: 'メニューURLが無効です',
    MSG_LOADING_FRAME: '読み込み中...',
    NO_APP: '利用可能なアプリケーションがありません',
    BTN_CHANGE_APP: 'アプリケーションを変更'
  },
  SUPER: {
    TITLE_ASSIGN_OU_ADMIN: '管理者を割り当て',
    TITLE_RESET_ADMIN_CIPHER: '管理者パスワードをリセット',
    TITLE_CONFIRM_RESET_CIPHER: '管理者パスワードをリセットしてよろしいですか?',
    MSG_CONFIRM_RESET_CIPHER: '管理者パスワードのリセット用メールの送信先:',
    MSG_CREATE_USER_AS_ADMIN: '管理者アカウントを作成します',
    MSG_CONFIRM_SET_ADMIN: 'ユーザーを管理者として割り当てますか?',
    TXT_CONFIRM_SET_ADMIN: '{0}が管理者として割り当てられ、招待メールが{1}に送信されます。メールを送信しますか?',
    TXT_EDGE_CONFIRM_SET_ADMIN: '{0}を管理者として割り当てますか?',
    TITLE_OU_NAME: 'OU名',
    TITLE_CURRENT_OU: '現在の管理者',
    TITLE_NOT_ASSIGN: '(管理者が割り当てられていません)',
    MSG_CONFIRM_CHANGE_ADMIN: '管理者を変更してよろしいですか?',
    TXT_CONFIRM_CHANGE_ADMIN1: '管理者が{0}から{1}に変わります。',
    TXT_CONFIRM_CHANGE_ADMIN2: '招待メールが{0}に送信されます。メールを送信しますか?',
    MSG_SEND_EMAIL_SUCCESSFULLY: 'メールが送信されました'
  },
  PLUGIN: {
    BTN_REGISTER_PLUGIN: 'プラグインを登録',
    TITLE_PLUGIN_NAME: '名前',
    TITLE_NAME_DEFAULT: '名前',
    TITLE_NAME_ENGLISH: '名前(英語)',
    TITLE_URL: 'URL',
    TITLE_DESCRIPTION: '説明',
    BTN_ASSIGN_OU: 'OUを割り当て',
    HINT_ADD_PLUGIN_NAME_PLACEHOLDER: 'プラグイン名を入力してください',
    HINT_ADD_PLUGIN_URL_PLACEHOLDER: '有効なURLを入力してください',
    BTN_CANCELTEXT: 'キャンセル',
    BTN_OKTEXT: '提出',
    TITLE_MODAL_REGISTER_PLUGIN: 'プラグインを登録',
    TITLE_MODAL_MODIFY_PLUGIN: 'プラグインを編集',
    TITLE_MODAL_ASSIGN_OU: 'OUを割り当て',
    TITLE_MODAL_DELETE_PLUGIN: 'プラグインを削除',
    CONTENT_MODAL_DELETE_PLUGIN: '削除したプラグインは元に戻すことはできません。プラグインを削除してよろしいですか?',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED1: 'プラグインがユーザーに割り当てられており、削除できません。',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED2: 'プラグインを削除する前に、OUの割り当てを解除してください。',
    INPUT_NAME_NEEDED: 'プラグイン名は必須です',
    INPUT_NAME_CHINESE_NEEDED: 'プラグイン名(ZH)は必須です',
    INPUT_NAME_ENGLISH_NEEDED: 'プラグイン名(EN)は必須です',
    INPUT_URL_NEEDED: 'プラグインURLは必須です',
    INPUT_DESCRIPTION_NEEDED: 'プラグインの説明は必須です',
    MESSAGE_REGISTER_SUCCEED: 'プラグインが登録されました',
    MESSAGE_MODIFY_SUCCEED: 'プラグインが更新されました',
    MESSAGE_ASSIGN_OU: 'OUが割り当てられました',
    MESSAGE_DELETE_SUCCESS: 'プラグインが削除されました',
    MSG_ASSIGN_OU: 'プラグインがOUに割り当てられると、OU管理者はプラグインを使用できます。',
    TXT_OU: 'OU',
    TXT_SELECTED_OU: '選択したOU'
  },
  MESSAGE: {
    TITLE_NAME: '通知',
    TXT_SHOW_ALL: 'すべて表示',
    TXT_NO_MESSAGE: 'メッセージなし',
    TXT_TO_SOUND: 'サウンドを有効にする',
    TXT_TO_MUTE: 'サウンドを無効にする',
    TXT_DISABLE_DIALOG: 'ポップアップを無効にする',
    TXT_DIALOG: 'ポップアップを有効にする',
    TXT_CLOSE_DIALOG: '閉じる',
    TXT_APP_HINT1: '{0}件のアプリケーションと{1}件のアラートが残っている',
    TXT_APP_HINT2: '折り畳む',
    TXT_MESSAGE: 'メッセージ',
    TXT_LOAD_MORE: 'さらに読み込む',
    TXT_LOADING: '読み込み中',
    TXT_LOAD_FAILED: '読み込みに失敗しました。もう一度お試しください。'
  },
  DOMAIN: {
    BTN_ADD_DOMAIN: 'ドメインを追加',
    TXT_DOMAIN_NAME: 'ドメイン名',
    TXT_DOMAIN_URL: 'URL',
    TXT_DOMAIN_DESCRIPTION: '説明',
    TITLE_ADD_DOMAIN: 'ドメインを追加',
    MESSAGE_ADD_SUCCEED: 'ドメインが追加されました',
    TITLE_MODIFY_DOMAIN: 'ドメインを編集',
    MESSAGE_MODIFY_SUCCEED: 'ドメイン情報が更新されました',
    TITLE_MODAL_DELETE_DOMAIN: 'ドメインを削除',
    CONTENT_MODAL_DELETE_DOMAIN: '削除したドメインは元に戻すことはできませんドメインを削除してよろしいですか? ',
    MESSAGE_DELETE_SUCCESS: 'ドメインが削除されました',
    HINT_ADD_URL_PLACEHOLDER: '有効なURLを入力してください',
    TXT_ADD_DOMAIN:
      '企業または組織のドメインを追加して、ドメインユーザーアカウントを追加できるようにします',
    TXT_DOMAIN_NAME_NEEDED: 'ドメイン名は必須です',
    TXT_DOMAIN_URL_NEEDED: 'ドメインURLは必須です',
    TXT_AUTO_IMPORT: 'Auto-import Users', // TODO
    TXT_YES: 'Yes', // TODO
    TXT_NO: 'No', // TODO
    TXT_ROLES: 'ロール',
    TXT_USER_GROUPS: 'ユーザーグループ',
    TXT_SELECT_ROLES: 'Select roles', // TODO
    TXT_SELECT_USERGROUPS: 'Select user groups', // TODO
    HINT_NOT_AUTO_IMPORT: 'Manually create EnOS users for SSO in advance', // TODO
    HINT_AUTO_IMPORT: 'Application Portal supports automatically importing SSO users and assigning to roles and user groups. Select "yes" to automatically assign SSO users to selected roles and user groups; Select "No", you need to manually create users in advance in Application Portal.', // TODO
    HINT_AUTO_IMPORT_NECESSARY: 'You need to specify whether to auto-import users', // TODO
    TITLE_DOUBLE_CHECK: 'Are you sure to disable auto-import users?', // TODO
    TXT_DOUBLE_CHECK: 'After disabling auto-import users, you need to create users for SSO in advance. The existing users will remain in current roles and user groups.' // TODO
  },
  SECURITY: {
    TAB_CIPHER_RULES: 'パスワード規則',
    TAB_LOGIN_SECURITY: 'ログインセキュリティ',
    MSG_CIPHER_RULES: '次のパスワード規則は環境内のすべてのユーザーカウントに適用されます',
    MSG_LOGIN_SECURITY: '次のログインセキュリティ規則は環境内のすべてのユーザーアカウントに適用されます',
    LABEL_CIPHER_REQUIRED: '必須文字',
    TITLE_CIPHER_REQUIRED: '1つ以上のオプションを選択してください',
    LABEL_CIPHER_LENGTH: 'パスワードの長さ',
    LABEL_CIPHER_LENGTH_AFTER: '文字',
    LABEL_CIPHER_LENGTH_BOTTOM: '8～20文字をサポート',
    LABEL_CIPHER_RETRY_CONSTRAINT: '再試行の制限',
    LABEL_CIPHER_RETRY_CONSTRAINT_AFTER: '回/時間',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: '1時間内に許容される誤ったパスワード入力の回数。この制限を超えると、アカウントが1時間ロックされます。1～10回の再試行に対応します。',
    LABEL_REPEAT_TIMES: '再利用制限',
    LABEL_REPEAT_TIMES_AFTER: '回',
    LABEL_REPEAT_TIMES_BOTTOM: 'ユーザーがパスワードをリセットまたは変更するときに再利用できない以前のパスワードの数。1～5個のパスワードに対応します。',
    LABEL_SINGLE_OR_MORE: '複数ログインセッション',
    LABEL_SINGLE_OR_MORE_BOTTOM: '有効にすると、ユーザーは同時に複数の場所から1つのアカウントにログインできます。',
    TITLE_OPEN_MORE_LOGIN: '複数ログインセッションを有効にする',
    CONTENT_OPEN_MORE_LOGIN: '有効にすると、ユーザーは同時に複数の場所から1つのアカウントにログインできます。',
    TITLE_CLOSE_MORE_LOGIN: '複数ログインセッションを無効にする ',
    CONTENT_CLOSE_MORE_LOGIN: '無効にすると、現在ログインしているユーザーはログアウトされ、同じアカウントに別の場所からログインしたことが通知されます。',
    LABEL_SESSION_VALID_TIME: 'セッションタイムアウト',
    LABEL_SESSION_VALID_TIME_AFTER: '分',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'ユーザーがログアウトされるまでに非アクティブな状態を維持できる期間。15～720分に対応します。',
    LABEL_IP_ADDRESS: 'IPアドレス',
    LABLE_IP_ADDRESS_WHITE: 'ホワイトリスト',
    LABEL_IP_ADDRESS_BLACK: 'ブラックリスト',
    PLACEHOLD_IP_ADDRESS: 'IPアドレスをカンマで区切ってください',
    LABEL_IP_ADDRESS_BOTTOM_WHITE: 'ホワイトリスト：内部ユーザーはリストに記載されたIPアドレスからのみログインできます。',
    LABEL_IP_ADDRESS_BOTTOM_BLACK: 'ブラックリスト：内部ユーザーはリストに記載されたIPアドレスからログインできません。',
    TITLE_SWITCH_IP_LIST_MODAL: 'ホワイト/ブラックリストを切り替え',
    CONTENT_SWITCH_IP_LIST_MODAL: 'リストに記載されたIPアドレスは、切り替え後に失われます。切り替えてよろしいですか?',
    TITLE_ILLEGAL_IP: 'IPアドレスまたはCIDRアドレスが無効です',
    TITLE_LENGTH_BEYOND: '最大500件のIPアドレスを追加できます',
    TXT_LENGTH_HINT: '{0}～20文字まで入力可能です。',
    TXT_UPPERCASE_HINT: '大文字は必須です',
    TXT_LOWERCASE_HINT: '小文字は必須です',
    TXT_MUNBER_HINT: '数字は必須です',
    TXT_SPECIAL_CHARACTER_HINT: '特殊文字(!@#%&*()[]{}-_=|)は必須です',
    MESSAGE_SET_CIPHER_RULES_SUCCESS: 'パスワード規則が更新されました',
    MESSAGE_SET_SECURITY_LOGIN_SUCCESS: 'ログインセキュリティ設定が更新されました',
    TXT_CIPHER_TYPE_NUMBER: '数字',
    TXT_CIPHER_TYPE_UPPERCASE: '大文字',
    TXT_CIPHER_TYPE_LOWERCASE: '小文字',
    TXT_CIPHER_TYPE_CHARACTER: '特殊文字：!@#%&*()[]{}-_=|',
    BTN_SUBMIT_SECURITY: '変更を適用'
  },
  AUDIT: {
    TXT_AUDIT_LOG: '監査ログには、OU内のすべてのユーザーの過去{0}日間のログイン、ログアウト、システム操作イベントが含まれます。',
    BTN_EXPORT: 'エクスポート',
    BTN_EXPORT_LOADING: 'エクスポート中',
    TITLE_EVENT_TIME: 'イベント時間',
    TITLE_ACCOUNT: 'ユーザー',
    TITLE_EMAIL: 'メールアドレス',
    TITLE_ACCOUNT_TYPE: 'アカウントの種類',
    TITLE_ASSET_TYPE: 'リソースの種類',
    TITLE_EVENT_NAME: 'イベント',
    TITLE_EVENT_DESCRIPTION: '説明',
    TITLE_IP_ADDRESS: 'IPアドレス',
    TITLE_OPERATION: '操作',
    TITLE_SEARCH_ACCOUNT: 'ユーザーを検索',
    BTN_SEARCH_ACCOUNT: '検索',
    BTN_RESET_ACCOUNT: 'リセット',
    BTN_VIEW_CONTENT: '詳細を表示',
    TXT_SEMICOLON: '；',
    TITLE_MODAL_DETAIL: 'イベントの詳細',
    TITLE_MODAL_EXPORT: 'ログをエクスポート',
    TXT_MODAL_EXPORT1: '選択した期間の監査ログをエクスポートしますか？',
    TXT_MODAL_EXPORT2: '過去{0}日前に発生したイベントをエクスポートする必要がある場合は、システム管理者にお問い合わせください。',
    TITLE_DETAIL_EDIT_BEFORE: '編集前',
    TITLE_DETAIL_EDIT_AFTER: '編集後',
    TITLE_EXPORT_AUDIT_LOG: 'audit_log_{0}.xlsx',
    TITLE_DOWNLOAD_AUDIT_LOG: 'インポートされたファイルをダウンロード'
  },
  OU_SECURITY: {
    TXT_MFA: '多要素認証',
    TXT_LOGIN_PROTECTION: 'ログイン保護',
    BTN_SUBMIT_SECURITY: '変更を適用',
    TXT_CLOSE_LOGIN_PROTECTION: '無効',
    TXT_OPEN_EMAIL_AUTH: 'メール認証を有効にする',
    TXT_EMAIL_AUTH_HINT:
      'ユーザーがシステムにログインするときに、メールアドレスに送信された確認コードを入力する追加の手順を実行する必要があります。',
    TXT_LOGIN_VALIDATE: 'ログイン認証',
    LABEL_EMAIL_ADDRESS: 'メールアドレス',
    LABEL_VERITIFICATION_CODE: '確認コード',
    BTN_SEND_CODE: '確認コードを送信 ',
    TXT_INPUT_CODE: '確認コードを入力してください',
    TXT_BACK_TO_LOGIN: 'ログインに戻る',
    HINT_CODE_SENDED: '確認コードがメールで送信されました',
    HINT_WRONG_CODE: '確認コードが有効ではありません。もう一度お試しください。',
    HINT_CODE_REQUIRED: '確認コードを入力してください',
    BIN_RESEND_CODE: '再送信',
    PRMTMSG_SEND_CODE_SUCCEED: '多要素認証設定が更新されました',

    MSG_CIPHER_RULES: '次のパスワード規則はOU内のすべてのユーザーアカウントに適用されます',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: '1時間以内に許容される誤ったパスワード入力の回数。この制限を超えると、アカウントが{0}分ロックされます。1～10回の再試行に対応します。',
    LABEL_REPEAT_TIMES_BOTTOM: '再利用できない以前のパスワードの数。1～5個のパスワードに対応します。',
    LABEL_SESSION_VALID_TIME_AFTER: '時間',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'ユーザーがログアウトされるまでに非アクティブな状態を維持できる期間。1～240時間まで対応します。',
    TXT_SESSION_VALID_TIME: 'セッションタイムアウト'

  },
  LANDING_PAGE: {
    LABEL_SITE_TIME: 'Site Time',
    HINT_CUSTOMIZE: 'Customzie',
    BTN_ADD_WIDGET: 'Add Widget',
    BTN_SAVE: 'Save',
    BTN_EXIT: 'Exit',
    PLACEHOLD_SEARCH_NAME: 'Search by name',
    TXT_NO_MATCH: 'No matching results',
    BTN_ADD_TO_PAGE: 'Add to Page',
    TITLE_EXIT_CONFIRM: 'Confirm to Exit',
    TXT_UNSAVE_TIP: 'Unsaved configurations will be lost',
    BTN_CANCEL: 'Cancel',
    MSG_FAILED_TO_GET_ASSET: 'Failed to get asset tree',
    TXT_DAY: 'Day',
    TXT_MONTH: 'Month',
    TXT_YEAR: 'Year',
    TXT_MTD: 'MTD',
    TXT_30d: '30d',
    TXT_QTD: 'QTD',
    TXT_3m: '3m',
    TXT_YTD: 'YTD',
    TXT_12m: '12m',
    TXT_Custom: 'Custom',
    LABEL_TIME_INTERVAL: 'Time Interval: ',
    LABEL_SITEM_SELECTED: 'Site: Selected ({0})'
  }
};

export default locale;
